import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line, Bar, Doughnut } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

interface ChartProps {
  type: 'line' | 'bar' | 'doughnut';
  data: any;
  options?: any;
  height?: number;
}

export function Chart({ type, data, options = {}, height = 200 }: ChartProps) {
  const defaultOptions = React.useMemo(() => ({
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: type === 'doughnut',
      },
    },
    animation: {
      duration: 0 // Disable animations to prevent stretching
    },
    ...options,
  }), [type, options]);

  const commonProps = React.useMemo(() => ({
    data,
    options: defaultOptions,
    height,
  }), [data, defaultOptions, height]);

  return (
    <div style={{ height: `${height}px`, width: '100%', position: 'relative' }}>
      {(() => {
        switch (type) {
          case 'line':
            return <Line {...commonProps} />;
          case 'bar':
            return <Bar {...commonProps} />;
          case 'doughnut':
            return <Doughnut {...commonProps} />;
          default:
            return <div className="text-center text-gray-500">Unsupported chart type</div>;
        }
      })()}
    </div>
  );
}
